import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { UsersService } from '../services/users.service';
import { environment } from 'src/environments/environment';
import { UserProfileInfo } from '../models/user-profile.model';
import { CoreRoutes } from '../app-core/core-routes';
import { AdminContext } from '../app-admin/admin-context';
import { ContextService, UnauthenticatedContext } from '../services/context.service';
import { ModuleName } from '../models/ienvironment';

@Injectable({
	providedIn: 'root',
})
export class AuthGuard  {
	constructor(
		private usersService: UsersService,
		private router: Router,
		private readonly _contextService: ContextService,
	) {}
	
	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot,
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		if(!this._contextService.isAuthenticated){
			console.log(`AuthGuard - Unauthenticated redirect`, 'color: orange');
			return this.router.parseUrl('/login');
		}
		return true;
		
		// const user = this.usersService.currentUser;
		// const paths = route.url.map((e) => e.path);
		// console.log('paths', paths);
		// return this.checkAccess(paths, user);
		
		// return this.usersService.currentUserInfo$.pipe(
		// 	filter((user) => !!user),
		// 	map((user) => {
		// 		const paths = route.url.map((e) => e.path);
		// 		console.log('paths', paths);
		// 		return this.checkAccess(paths, user);
		// 	}),
		// );
	}

	// private isEnabledInEnv(path: ModuleName): boolean {
	// 	return (
	// 		environment.bottomTabs.includes(path) ||
	// 		environment.topTabs.includes(path) ||
	// 		environment.navigationCards.some((e) => e.name === path)
	// 	);
	// }

	// private checkAccess(paths: string[], user: UserProfileInfo): UrlTree | boolean {
	// 	const accessMap = {
	// 		[CoreRoutes.Agenda]: user.flagViewAgenda || user.flagViewAgendaAdmin,
	// 		[CoreRoutes.Customers]: user.flagViewClienti || user.flagViewClientiAdmin,
	// 		[CoreRoutes.Fiches]: user.flagViewFiches || user.flagViewFichesAdmin,
	// 		[CoreRoutes.Reports]: user.flagViewReports || user.flagViewReportAdmin,
	// 		[CoreRoutes.Menu]: this.isEnabledInEnv('menu') && user.flagViewCatalog,
	// 		[CoreRoutes.Gallery]: this.isEnabledInEnv('gallery') && user.flagViewGallery,
	// 		archive: this.isEnabledInEnv('archive') && user.flagViewArchive,
	// 		seminars: this.isEnabledInEnv('seminars') && user.flagViewEvents,
	// 		appointments: this.isEnabledInEnv('appointments'),
	// 	};
	//
	// 	for (const path of paths) {
	// 		if (accessMap[path] === false) {
	// 			return this.router.parseUrl(CoreRoutes.ClientsHomePath);
	// 		}
	// 	}
	//
	// 	return true;
	// }
}
